// keep as flat as possible and keep in sync with the view-structure
export const routenames = {
  activation: Symbol('activation'),
  dashboard: Symbol('dashboard'),
  eula: Symbol('eula'),
  dataTypes: Symbol('dataTypes'),
  quantities: {
    index: Symbol('quantities.index'),
    overview: Symbol('quantities.overview'),
    add: Symbol('quantities.add'),
    edit: Symbol('quantities.edit'),
    details: Symbol('quantities.details'),
  },
  enumerations: {
    index: Symbol('enumerations.index'),
    overview: Symbol('enumerations.overview'),
    add: Symbol('enumerations.add'),
    edit: Symbol('enumerations.edit'),
    details: Symbol('enumerations.details'),
  },
  texts: {
    index: Symbol('texts.index'),
    overview: Symbol('texts.overview'),
    add: Symbol('texts.add'),
    edit: Symbol('texts.edit'),
    details: Symbol('texts.details'),
  },
  units: {
    index: Symbol('units.index'),
    overview: Symbol('units.overview'),
    add: Symbol('units.add'),
    edit: Symbol('units.edit'),
    details: Symbol('units.details'),
  },
  qaEquipment: {
    root: Symbol('qaEquipment.root'),
    index: Symbol('qaEquipment.index'),
    add: {
      configuration: Symbol('qaEquipment.add.configuration'),
      fromCatalog: Symbol('qaEquipment.add.fromCatalog'),
      otherManufacturer: Symbol('qaEquipment.add.otherManufacturer'),
    },
    details: Symbol('qaEquipment.details'),
    edit: Symbol('qaEquipment.edit'),
    overview: Symbol('qaEquipment.overview'),
  },
  forgotPassword: Symbol('forgotPassword'),
  home: Symbol('home'),
  installation: Symbol('installation'),
  jobConfigurations: {
    index: Symbol('jobConfigurations.index'),
    add: Symbol('jobConfigurations.add'),
    copy: Symbol('jobConfigurations.copy'),
    details: Symbol('jobConfigurations.details'),
    edit: Symbol('jobConfigurations.edit'),
    overview: Symbol('jobConfigurations.overview'),
  },
  jobOccurrences: {
    index: Symbol('jobOccurrences.index'),
    overview: Symbol('jobOccurrences.overview'),
    execution: Symbol('jobOccurrences.execution'),
    report: Symbol('jobOccurrences.report'),
  },
  licenses: Symbol('licenses'),
  signIn: Symbol('signIn'),
  signOut: Symbol('signOut'),
  settings: Symbol('settings'),
  medicalSystems: {
    root: Symbol('medicalSystems.root'),
    index: Symbol('medicalSystems.index'),
    add: Symbol('medicalSystems.add'),
    details: Symbol('medicalSystems.details'),
    edit: Symbol('medicalSystems.edit'),
    overview: Symbol('medicalSystems.overview'),
  },
  preferences: Symbol('preferences'),
  resetPassword: Symbol('resetPassword'),
  resultManagement: Symbol('resultManagement'),
  software: Symbol('software'),
  update: Symbol('update'),
  maintenance: Symbol('maintenance'),
  sslCertificate: Symbol('sslCertificate'),
  installationName: Symbol('installationName'),
  emailSettings: Symbol('emailSettings'),
  databaseSettings: Symbol('databaseSettings'),
  backup: Symbol('backup'),
  tasks: {
    index: Symbol('tasks.index'),
    add: Symbol('tasks.add'),
    details: Symbol('tasks.details'),
    edit: Symbol('tasks.edit'),
    overview: Symbol('tasks.overview'),
  },
  protocols: {
    index: Symbol('protocols.index'),
    overview: Symbol('protocols.overview'),
    details: Symbol('protocols.details'),
    add: Symbol('protocols.add'),
    edit: Symbol('protocols.edit'),
  },
  reports: Symbol('reports'),
  trends: Symbol('trends'),
  trendSelection: Symbol('trendSelection'),
  trendDisplay: Symbol('trendDisplay'),
  userManagement: Symbol('userManagement'),
  accounts: {
    index: Symbol('accounts.index'),
    add: Symbol('accounts.add'),
    details: Symbol('accounts.details'),
    edit: Symbol('accounts.edit'),
    overview: Symbol('accounts.overview'),
  },
  roles: {
    index: Symbol('roles.index'),
    details: Symbol('roles.details'),
    edit: Symbol('roles.edit'),
    overview: Symbol('roles.overview'),
  },
  workManagement: Symbol('workManagement'),
  noPermissions: Symbol('noPermissions'),
  notFound: Symbol('notFound'),
};
